import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Control, actions, Errors } from 'react-redux-form';
import { Grid, Row, Col, Button, FormGroup } from 'react-bootstrap';
import PageTitle from '../../common/page-title';
import { getQuestions, verifyQuestions } from '../../../actions/login';
import LockPopup from '../lock-popup';
import TextViewer from '../../common/editor/text-viewer';
import './style.css';

class SeqQuestionsForm extends Component {

  constructor(props) {
    super(props);
    this.state = { show: false };
  }

  componentWillMount() {
    const { dispatch } = this.props;
    dispatch(actions.reset('deep.resetPW.step3'));
  }

  componentDidMount() {
    this.props.dispatch(getQuestions());
  }

  handleSubmit = (payLoad) => {
    const { dispatch } = this.props;
    dispatch(actions.submit('deep.resetPW.step3', verifyQuestions(payLoad)
      .catch((error) => {

        dispatch({ type: 'VERIFY_ANSWERS_REJECTED', payLoad: error.response.data });

        const errors = error.response.data.errors;
        let rejectErrors = [];
        if (Object.prototype.toString.call(errors) === '[object Array]') {
          errors.forEach((curr) => {
            if (curr === 'INVALID_SECURITY_ANSWERS') {
              rejectErrors.push({ invalid_answers: true })
            }
            if (curr === 'INVALID_CREDENTIALS') {
              rejectErrors.push({ invalid_creds: true })
            }
            if (curr === 'INVALID_STATE') {
              rejectErrors.push({ invalid_state: true })
            }
            if (curr === 'ACCOUNT_LOCKED') {
              rejectErrors.push({ answers_exceeded: true });
              this.setState({ show: true });
            }
          });
          return Promise.reject(rejectErrors);
        } else {
          return Promise.reject(errors);
        }

      })
    ));

  };

  render() {

    return (
      <Grid fluid className="security-questions">
          <Row>
            <Col lg={12}>
              <PageTitle>Security questions</PageTitle>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <TextViewer pageSlug='enter-security-questions'></TextViewer>
            </Col></Row>
          <Row>
            <Col lg={6}>
              <Form model="deep.resetPW.step3" className="questions-form"
                onSubmit={(values) => this.handleSubmit(values)}>

                <FormGroup>
                  <label htmlFor=".question1">{this.props.questions.questions.question1}</label>
                  <Control.text className="form-control"
                    validators={{ required: (val) => val !== '' }}
                    validateOn="change"
                    model=".answer1" type="text" />
                  <Errors className="errors"
                    model=".answer1"
                    show={{
                      touched: true,
                      focus: false
                    }}
                    messages={{
                      required: (val) => 'This field is required'
                    }} />
                </FormGroup>


                <FormGroup>
                  <label htmlFor=".question2">{this.props.questions.questions.question2}</label>
                  <Control.text className="form-control"
                    validators={{ required: (val) => val !== '' }}
                    validateOn="change"
                    model=".answer2" type="text" />
                  <Errors className="errors"
                    model=".answer2"
                    show={{
                      touched: true,
                      focus: false
                    }}
                    messages={{
                      required: (val) => 'This field is required'
                    }} />
                </FormGroup>

                <Errors className="errors"
                  model="deep.resetPW.step3"
                  messages={{
                    invalid_answers: 'Invalid security answers given',
                    invalid_state: 'Invalid state',
                    invalid_creds: 'Invalid Credentials',
                    answers_exceeded: 'Security answer attempts exceeded'
                  }} />

                <Button type="submit"
                  disabled={!this.props.formValid}
                  className="red-btn pull-right submit">
                  Submit
              </Button>

              </Form>
            </Col>
          </Row>
        { this.state.show && <LockPopup route="/login" />}
      </Grid>
    );

  }
}

const mapStateToProps = (state) => {
  return {
    questions: state.questions,
    formValid: state.deep.forms.resetPW.step3.$form.valid
  };
};

export default connect(mapStateToProps)(SeqQuestionsForm);



// WEBPACK FOOTER //
// ./src/components/auth/security-questions/index.jsx